export default "__VITE_ASSET__f9512b14__"